export enum NoteVisibility {
    Invoice = 'INVOICE',
    SalesOrder = 'SALES_ORDER',
    PurchaseOrder = 'PURCHASE_ORDER',
    Demand = 'DEMAND',
    Inquiry = 'INQUIRY',
}

const translationObject: { [Key in NoteVisibility]: string } = {
    [NoteVisibility.Invoice]: 'app.note.visibility.invoice',
    [NoteVisibility.PurchaseOrder]: 'app.note.visibility.purchaseOrder',
    [NoteVisibility.Inquiry]: 'app.note.visibility.inquiry',
    [NoteVisibility.SalesOrder]: 'app.note.visibility.salesOrder',
    [NoteVisibility.Demand]: 'app.note.visibility.demands',
};

export const getNoteVisibilityTranslationId = (transitionTarget: NoteVisibility): string => {
    return translationObject[transitionTarget];
};
